<template>
  <div>
    Firestore ID
    <pre>{{ id }}</pre>
    <hr>
    Wheels
    <pre>{{ dump }}</pre>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useUserStore } from '@/stores/useUserStore';

const id = ref('Loading...');
const dump = ref('Loading...');
const userStore = useUserStore();

onMounted(async () => {
  if (await userStore.userIsLoggedInAction()) {
    id.value = await userStore.getUid();
    await userStore.loadSavedWheels();
    await userStore.loadSharedWheels();
    const wheels = {
      savedWheels: userStore.savedWheels,
      sharedWheels: userStore.sharedWheels
    };
    dump.value = JSON.stringify(wheels, null, 2);
  }
  else {
    id.value = '<Sign-in required>';
    dump.value = '<Sign-in required>';
  }
});
</script>
